import React from "react";

export const getNavbarOptions = ({
  handleLogout,
  handleInviteUser,
  currentRoute, // Pass the current route as a prop
  handleSwitchRole, // Function to handle role switching
}: {
  handleLogout: () => void;
  handleInviteUser: () => void;
  currentRoute: string;
  handleSwitchRole: () => void;
}) => {
  const isAdmin = currentRoute.includes("admin");
  return [
    // {
    //   label: "Invite User",
    //   key: "invite",
    //   isDisabled: false,
    //   frontIcon: <></>,
    //   action: () => {
    //     handleInviteUser();
    //   },
    // },
    {
      label: isAdmin ? "Switch to dashboard" : "Switch to admin",
      key: "switch_role",
      isDisabled: false,
      frontIcon: <></>,
      action: () => {
        handleSwitchRole();
      },
    },
    {
      label: "Logout",
      key: "logout",
      isDisabled: false,
      frontIcon: <></>,
      action: () => {
        handleLogout();
      },
    },
  ];
};
